<template>
	<b-modal
		id="modal-intro"
		title="BootstrapVue"
		no-close-on-esc
		no-close-on-backdrop
		no-fade
	>
		<div class="text-center">
			<img src="/logo-big-white.svg" class="logo img-fluid" />
			<p class="p-small">
				<a href="https://underlineme.com" target="_blank">Homepage</a
				><span>&nbsp;•&nbsp;</span
				><a href="https://underlineme.com/contact" target="_blank">Support</a>
			</p>
		</div>
		<b-tabs no-fade content-class="mt-3" v-model="tabIndex">
			<!-- Login form -->
			<b-tab title="First" active>
				<h3 class="align-center">Hello🖐 Sign in to your dashboard</h3>
				<b-form @submit.prevent="onLoginSubmit">
					<b-form-group id="input-group-1" label-for="input-1">
						<b-form-input
							id="username"
							type="email"
							v-model="loginForm.username"
							placeholder="acme@email.com"
						></b-form-input>
						<b-form-text v-if="$v.loginForm.username.$error">
							Please enter your email
						</b-form-text>
						<b-form-input
							id="password"
							type="password"
							v-model="loginForm.password"
							placeholder="********"
						></b-form-input>
						<b-form-text v-if="$v.loginForm.password.$error">
							Please enter your password
						</b-form-text>
					</b-form-group>
					<b-button
						type="submit"
						variant="primary"
						:class="[{ disabled: lock === true }]"
						>Login <b-spinner :class="['ml-1']" small v-if="lock"></b-spinner
					></b-button>
					<div class="form-error" v-if="errorMessage">
						{{ errorMessage }}
					</div>
					<br />
					<br />
					<p>
						Forgot your password?
						<a href="#" @click="tabIndex = 2">Reset password.</a>
					</p>
					<p>
						Don't have an account? Install the
						<a
							href="https://chrome.google.com/webstore/detail/underlineme-highlighter-f/bfgkgjjcgcfdjdcdcicnekhhldinkkhk"
							target="_blank"
							>extension.</a
						>
						<!-- <a href="#" @click="tabIndex++">Signup</a> for a free trial. -->
					</p>
				</b-form>
			</b-tab>
			<!-- Login form END -->
			<!-- Reset password form -->
			<b-tab title="Second">
				<h3>Signup</h3>
				<p class="p-small">
					Start off with all features but you can only take 50 annotations.
				</p>
				<p class="p-small">Upgrade anytime once you're ready to commit.</p>
				<Signup @onSuccess="onLogin"> </Signup>
			</b-tab>
			<!-- Password reset form -->
			<b-tab title="third">
				<h3>Reset Password</h3>
				<b-form
					@submit.prevent="onResetpasswordSubmit"
					v-if="!hasResetPasswordSubmit"
				>
					<b-form-group
						label="Email Address"
						label-for="signupform-name"
						description="Enter the email address you signed up with."
					>
						<b-form-input
							id="resetpasswordform-name"
							v-model="resetpasswordForm.email"
							type="email"
							required
							placeholder="name@email.com"
						></b-form-input>
					</b-form-group>
					<b-button
						type="submit"
						variant="primary"
						:class="[{ disabled: lock === true }]"
						>Reset Password&nbsp;<b-spinner
							:class="['ml-1']"
							small
							v-if="lock"
						></b-spinner
					></b-button>
				</b-form>
				<b-form-valid-feedback :state="hasResetPasswordSubmit">
					You will receive a link shortly in your email inbox for a password
					reset link.
				</b-form-valid-feedback>
				<p class="p-small" v-if="hasResetPasswordSubmit">
					<br />
					<a href="#" @click.prevent="tabIndex = 0">Go back</a>
				</p>
			</b-tab>
			<!-- Password reset form END -->
			<!-- Set Password form -->
			<b-tab title="third">
				<h3>Reset password request</h3>
				<p>Set a new pasword for your account.</p>
				<b-form
					@submit.prevent="onSetPasswordSubmit"
					v-if="!hasSetpasswordSubmit"
				>
					<b-form-group label="New password" label-for="setpassword-name">
						<b-form-input
							id="setpassword-name"
							v-model="setpasswordForm.password"
							type="password"
							required
							placeholder="********"
						></b-form-input>
						<b-form-text v-if="$v.setpasswordForm.password.$error">
							Please make sure your password is 8 characters or longer
						</b-form-text>
					</b-form-group>
					<b-form-group
						label="Verify password"
						label-for="setpassword-password2"
					>
						<b-form-input
							id="setpassword-password2"
							v-model="setpasswordForm.password2"
							type="password"
							required
							placeholder="********"
						></b-form-input>
						<b-form-text v-if="$v.setpasswordForm.password2.$error">
							Please make sure your password is 8 characters or longer
						</b-form-text>
					</b-form-group>
					<b-button
						type="submit"
						variant="primary"
						:class="[{ disabled: lock === true }]"
						>Reset password and Sign in&nbsp;<b-spinner
							:class="['ml-1']"
							small
							v-if="lock"
						></b-spinner
					></b-button>
				</b-form>
				<b-form-valid-feedback :state="hasSetpasswordSubmit">
					Your password has been reset.
				</b-form-valid-feedback>
				<p class="p-small" v-if="hasSetpasswordSubmit">
					<br />
					<a href="#" @click.prevent="tabIndex = 0">Go back</a>
				</p>
			</b-tab>
			<!-- Set Password form END -->
		</b-tabs>
	</b-modal>
</template>

<script>
import { required, minLength, between } from 'vuelidate/lib/validators';
import queryString from 'query-string';

import Signup from '@/components/forms/signup.vue';

export default {
	components: {
		Signup,
	},
	data: function () {
		var obj = {
			lock: false,
			key: '',
			errorMessage: '',
			hasResetPasswordSubmit: false,
			hasSetpasswordSubmit: false,
			loginForm: {
				username: '',
				password: '',
			},
			resetpasswordForm: {
				email: '',
			},
			setpasswordForm: {
				token: '',
				password: '',
				password2: '',
			},
			tabIndex: 0,
		};
		return obj;
	},
	validations: {
		loginForm: {
			username: {
				required,
				minLength: minLength(3),
			},
			password: {
				required,
				minLength: minLength(3),
			},
		},
		resetpasswordForm: {
			email: {
				required,
			},
		},
		setpasswordForm: {
			password: {
				required,
				minLength: minLength(8),
			},
			password2: {
				required,
				minLength: minLength(8),
			},
		},
	},
	computed: {
		version: function () {
			return this.$store.getters.version;
		},
	},
	methods: {
		onLogin: function () {
			this.$bvModal.hide('modal-intro');
		},
		onLoginSubmit: function () {
			this.$v.$touch();
			if (!this.$v.loginForm.$invalid) {
				this.submitLogin();
			}
		},
		onResetpasswordSubmit: function () {
			this.$v.$touch();
			if (!this.$v.resetpasswordForm.$invalid) {
				this.submitResetpassword();
			}
		},
		onSetPasswordSubmit: function () {
			this.$v.$touch();
			if (
				!this.$v.setpasswordForm.$invalid &&
				this.setpasswordForm.password === this.setpasswordForm.password2
			) {
				this.submitSetpassword();
			}
		},
		submitSetpassword: function () {
			this.lock = true;
			this.$store
				.dispatch('user/changePasswordAndLogin', this.setpasswordForm)
				.then((status) => {
					if (status) {
						this.$bvModal.hide('modal-intro');
						let query = Object.assign({}, this.$route.query);
						delete query.reset;
						this.$router.replace({ query });
					}
					this.hasSetpasswordSubmit = true;
					this.lock = false;
				});
		},
		submitResetpassword: function () {
			this.lock = true;
			this.$store
				.dispatch('user/initiatePasswordReset', this.resetpasswordForm)
				.then(() => {
					this.hasResetPasswordSubmit = false;
					this.lock = false;
				});
		},
		submitLogin: function () {
			this.lock = true;
			this.$store
				.dispatch('user/login', this.loginForm)
				.then((res) => {
					this.$bvModal.hide('modal-intro');
					this.errorMessage = '';
					this.lock = false;
				})
				.catch((err) => {
					this.errorMessage =
						'No user with that email and password combination exists. Please enter re-enter your details';
					this.lock = false;
				});
		},
	},
	mounted: function () {
		this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
			let qs = queryString.parse(window.location.search);
			if (qs.email) {
				this.loginForm.username = qs.email.replace(/\/$/, '');
			}
			if (qs.reset) {
				this.setpasswordForm.token = qs.reset;
				setTimeout(() => {
					this.tabIndex = 3;
				}, 10);
			}
		});
	},
};
</script>

<style lang="scss">
#modal-intro___BV_modal_outer_ {
	.modal {
		padding-right: 0 !important;
		overflow: hidden;
	}

	.box {
		padding: 10px 14px;
		border-radius: 7px;
		background-color: $danger;
	}

	.modal-dialog {
		pointer-events: all;
		overflow-y: auto;
		max-width: initial;
		width: 100%;
		height: 100%;
		margin: 0;
		background-color: var(--g3);
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		box-shadow: inset 0 0 32px 0 rgba(0, 0, 0, 0.125),
			inset 0 0 256px 0 rgba(0, 0, 0, 0.125);

		@include scrollBars();

		&:after {
			content: '';
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			pointer-events: none;
			background: linear-gradient(
				350deg,
				rgba(255, 255, 255, 0.01) 0%,
				rgba(255, 255, 255, 0.04) 70%
			);
		}
	}
	.modal-backdrop {
		background-color: rgba(0, 0, 0, 1);
		opacity: 1;
	}
	.modal-header,
	.modal-footer {
		display: none;
	}
	.modal-content {
		height: auto;
		max-width: 480px;
		margin: 0 auto;
		border-radius: 0;
		position: relative;
		background-color: transparent;
		border: none;
		overflow-y: auto;
		padding: var(--spacer-lg) 0;

		.nav-tabs {
			display: none;
		}
		&:after {
			content: none;
		}
		.logo {
			max-width: 200px;
			margin-bottom: 8px;
		}
		.spinner-border {
			vertical-align: baseline;
			display: inline-block;
			width: 2rem;
			height: 2rem;
			border: 0.25em solid;
			border-right: 0.25em solid transparent;
			border-radius: 50%;
			animation: spinner-border 0.75s linear infinite;
		}
		.spinner-border-sm {
			width: 12px;
			height: 12px;
			border-width: 2px;
		}

		@keyframes spinner-border {
			to {
				-webkit-transform: rotate(1turn);
				transform: rotate(1turn);
			}
		}
	}
}
</style>
